var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Filas")]),_c('v-btn-toggle',{attrs:{"color":"primary","group":""}},_vm._l((_vm.itemsRows),function(item){return _c('v-btn',{key:item.ChrID,attrs:{"value":item.ChrID},on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(item.ChrDescription)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }